import { Checkbox } from 'antd'
import { CheckboxValueType } from 'antd/es/checkbox/Group'
import React from 'react'
import { RecepientToSend } from 'types/event/eventStep5'

interface GenderRecepientProps {
  recepientPayload: RecepientToSend
  setRecepientPayload: React.Dispatch<React.SetStateAction<RecepientToSend>>
}

const GenderRecepient: React.FC<GenderRecepientProps> = ({
  recepientPayload,
  setRecepientPayload,
}) => {
  const onChange = (checkedValues: CheckboxValueType[]) => {
    let genderValue: 'male' | 'female' | 'all'

    if (checkedValues.length === 2) {
      genderValue = 'all'
    } else if (checkedValues.length === 1) {
      genderValue = checkedValues[0] as 'male' | 'female'
    } else {
      genderValue = 'all'
    }

    setRecepientPayload({
      ...recepientPayload,
      gender: genderValue,
    })
  }

  const genderArr = [
    {
      id: 'male',
      label: 'Male',
    },
    {
      id: 'female',
      label: 'Female',
    },
  ]

  const getCheckedValues = () => {
    if (!recepientPayload?.gender) return []
    if (recepientPayload?.gender === 'all') return ['male', 'female']
    return [recepientPayload?.gender]
  }

  return (
    <div className="h-13 scroller">
      <div className="mt-20px">
        <Checkbox.Group
          onChange={onChange}
          value={getCheckedValues()}
          className="d-flex flex flex-column flex-wrap gap-10"
        >
          {genderArr.map(gender => {
            return (
              <Checkbox
                value={gender.id}
                key={gender.id}
                className="kids-listing-auth-adults"
              >
                <p>{gender.label}</p>
              </Checkbox>
            )
          })}
        </Checkbox.Group>
      </div>
    </div>
  )
}

export default GenderRecepient
